export default __webpack_public_path__ + "static/media/Q3.77409a3a.jpg";